import React from "react";
import { Skeleton } from "@mui/material";
import { profilePagePathsMap } from "./ProfileData";

const CardLoader = () => {
  return (
    <div className="profile-project-link">
      <div className="profile-project-card-loading">
        <div className="project-avatar">
          <Skeleton
            style={{
              height: 148,
              width: 148,
              transform: "inherit",
            }}
          />
        </div>

        <div className="details">
          <div className="project-shortname">
            <Skeleton style={{ width: "60%" }} />
          </div>
          <div className="project-info">
            <Skeleton style={{ width: "40%" }} />
          </div>
          <div className="project-title">
            <Skeleton style={{ width: "60%" }} />
          </div>
          <div className="project-desc small-text two-lines-max">
            <Skeleton />
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfileMainBodyLoader = ({
  projectSlug,
}: {
  projectSlug: string[] | undefined;
}) => {
  if (projectSlug?.[0] && profilePagePathsMap[projectSlug?.[0]] === "Members") {
    return <Skeleton variant="rectangular" style={{ height: 500 }} />;
  }

  return (
    <div className="profile-project-cards">
      <CardLoader />
      <CardLoader />
      <CardLoader />
      <CardLoader />
      <CardLoader />
      <CardLoader />
    </div>
  );
};

export default ProfileMainBodyLoader;
